import { Card, Space } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

// Shown on the Status step once every tier is verified — the only state that
// lands there (see resolveInitialStep). Never fall back to the pending copy.
function VerificationComplete() {
    const { t } = useTranslation();

    return (
        <div className={"flex mt-6"}>
            <Card className={"mx-auto text-center shadow-card"} style={{ maxWidth: 600 }}>
                <Space direction={"vertical"} align={"center"}>
                    <CheckCircleFilled style={{ fontSize: 32, color: "#52c41a" }} />
                    <div>
                        <h4>{t("accountVerification.verifiedTitle", "Your account has been verified.")}</h4>
                        <p>{t("accountVerification.verifiedDescription", "All verification steps are complete. No further action is needed.")}</p>
                    </div>
                </Space>
            </Card>
        </div>
    )
}

export default VerificationComplete;
